export const DISCOUNT_SUFFIX_RE = / -([1-9]|[1-9][0-9]|100)%$/;
export const isDiscountName = (name: string) => DISCOUNT_SUFFIX_RE.test(name.trim());
export const stripDiscountSuffix = (name: string) => name.trim().replace(DISCOUNT_SUFFIX_RE, "");
export const getDiscountFraction = (name: string): number | null => {
	const match = name.match(DISCOUNT_SUFFIX_RE);
	if (!match) return null;

	const percent = Number(match[1]);
	return percent / 100;
};
